import { clsx } from 'clsx';

import { spacingCSSVars } from '../../utils/spacing';
import type { AccordionSummaryProps } from './accordion.types';
import { useItemExpanded, useItemId } from './accordionItemContext';

import styles from './accordion.module.css';

export const AccordionSummary = ({
  children,
  className,
  'data-testid': testId,
  hidden = false,
  id,
  style,
  ...spacingProps
}: AccordionSummaryProps) => {
  const itemId = useItemId();
  const isExpanded = useItemExpanded();
  // Only show the summary content when hidden is false, and when it's not expanded.
  const isVisible = !hidden && !isExpanded;

  const spacingVars = {
    ...spacingCSSVars(spacingProps),
  };

  return (
    <div
      className={clsx(styles['accordionSummaryWrapper'], {
        [styles['accordionSummaryWrapper__visible']]: isVisible,
      })}
    >
      {isVisible && (
        <div
          className={styles['accordionSummary']}
          id={id}
          data-testid={testId ?? `accordion-summary-${itemId}`}
        >
          <div
            className={clsx(className, styles['accordionSummary_inner'])}
            style={{ ...spacingVars, ...style }}
          >
            {children}
          </div>
        </div>
      )}
    </div>
  );
};
